<template>
  <div class="quick-dates">
    <a role="button" :class="{ 'date-item': true, 'active': date.active }" v-for="date in dates" :key="date.date" @click="selectDate(date)">
      <div class="date-text">
        <div>{{ date.dateText }}</div>
        <div class="date-weekday">{{ date.weekday }}</div>
      </div>
      <div class="date-indicator">
        <div v-if="date.active" class="indicator" />
        <div v-else>{{ (stats[date.date] && (stats[date.date].count)) || 0 }}</div>
      </div>
    </a>
    <a role="button" class="date-item date-calendar" @click="toggleCalendar">
      <div class="date-text">日历</div>
      <div class="date-indicator" />
    </a>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { CHANGE_DATE } from '@/store/calendar/types';
import { FETCH_MULTI_STATS } from '@/store/course/types';

import mixinDatetime from '@/mixins/datetime';
import mixinFormatters from '@/mixins/formatters';

const { mapState: mapCalendarState, mapActions: mapCalendarActions } = createNamespacedHelpers('calendar');
const { mapState: mapCourseState, mapActions: mapCourseActions } = createNamespacedHelpers('course');

const MS_PER_DAY = 86400000;
const WEEKDAYS = [
    '周日', '周一', '周二', '周三', '周四', '周五', '周六',
];

export default {
    name: 'QuickDates',
    data() {
        return {};
    },
    computed: {
        ...mapCalendarState([
            'date',
        ]),
        ...mapCourseState([
            'stats',
        ]),
        dates() {
            const todayTs = Math.floor(Date.now() / MS_PER_DAY) * MS_PER_DAY;
            let firstTs = todayTs;
            let dateTs = todayTs;
            if (this.date) {
                dateTs = Math.floor((new Date(this.date)).getTime() / MS_PER_DAY) * MS_PER_DAY;
                if (dateTs >= todayTs) {
                    firstTs = dateTs - MS_PER_DAY;
                } else {
                    firstTs = dateTs;
                }
            }

            const dates = [];
            for (let i = 0; i < 4; i += 1) {
                const dateObject = this.formatDate(new Date(firstTs));
                dateObject.active = dateTs === firstTs;
                dates.push(dateObject);

                firstTs += MS_PER_DAY;
            }

            // 加载统计数据
            this.fetchMultiStats({
                dates: dates.map(d => d.date),
            });

            return dates;
        },
    },
    methods: {
        ...mapCalendarActions({
            changeDate: CHANGE_DATE,
        }),
        ...mapCourseActions({
            fetchMultiStats: FETCH_MULTI_STATS,
        }),
        formatDate(date) {
            const text = this.formatISODate(date);
            const dateText = text.substr(5, 5).replace('-', '/');
            const weekday = date.getDay();

            return {
                date: text,
                dateText,
                weekday: WEEKDAYS[weekday],
            };
        },
        toggleCalendar() {
            this.$emit('calendar');
        },
        selectDate(date) {
            if (date.active) {
                return;
            }

            const newDate = date.date;

            this.changeDate({
                date: newDate,
            });

            this.$emit('dateChanged', {
                date: newDate,
            });
        },
    },
    mixins: [
        mixinDatetime,
        mixinFormatters,
    ],
};
</script>

<style lang="scss" rel="stylesheet/scss">
$bg-color: #ff7245;
$bg-color-active: #df4a1b;
$border-color: #ffac92;
$indicator-bg-color: #fc9e80;
$indicator-bg-color-active: #e88768;
$indicator-text-color: #c93f14;
$indicator-color: #ffbca7;
$indicator-border-left-color: #cdcdcd;
$indicator-border-top-color: #dadada;

.quick-dates {
    display: flex;

    .date-item {
        width: 20%;
        flex: auto;
        text-align: center;
        font-size: 3.333333vw;
        cursor: pointer;

        &:not(:nth-child(5n + 1)) {
            .date-text {
                border-left: 1px solid $border-color;
            }

            .date-indicator {
                border-left: 1px solid $indicator-border-left-color;
            }
        }

        &.active {
            .date-text {
                background-color: $bg-color-active;
            }

            .date-indicator {
                background-color: $indicator-bg-color-active;
            }
        }
    }

    .date-text {
        height: 13.333333vw;
        background-color: $bg-color;
        color: white;
        line-height: 1.418604651;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .date-weekday {
        font-size: 2.4vw;
    }

    .date-indicator {
        height: 6.666667vw;
        background-color: $indicator-bg-color;
        color: $indicator-text-color;
        border-top: 1px solid $indicator-border-top-color;
        line-height: 6.666667vw;

        .indicator {
          display: inline-block;
          width: 0;
          height: 0;
          border-top: 2.533333vw solid $indicator-color;
          border-left: 1.266667vw solid transparent;
          border-right: 1.266667vw solid transparent;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/calendar/QuickDates.vue